<script lang="ts" setup>
import background from '~/assets/images/auth_background.jpg';

const { t } = useI18n();
</script>

<template>
  <div class="authPage">
    <NuxtImg
      :sizes="IMAGE_SIZES.halfScreen"
      format="webp"
      :src="background"
      :alt="t('image_alt')"
      class="authPage__image"
    />

    <NuxtPage class="authPage__container" />
  </div>
</template>

<i18n>
ru:
  image_alt: Вход или регистрация в приложение

en:
  image_alt: Sign in or register in the app
</i18n>

<style lang="scss">
.authPage {
  display: flex;
  height: 100dvh;
  background-color: #672146;
  position: relative;

  &__image {
    display: block;
    width: 50%;
    height: 100%;
    object-fit: cover;

    @include mq('sm') {
      display: none;
    }
  }

  &__container {
    width: 50%;
    min-height: 100%;

    @include mq('sm') {
      width: 100%;
    }
  }
}
</style>
